<div class="snackbar d-flex aling-items-center gap-2" [ngClass]="snackbarContent.type">
    @if (snackbarContent.type === snackBarTypes.SUCCESS)
    {
        <svg-icon src="assets/icons/check-circle.svg" class="snackbar-icon d-flex align-items-center justify-content-center"/>
    }
    @else if (snackbarContent.type === snackBarTypes.ERROR) 
    {
        <svg-icon src="assets/icons/error.svg" class="snackbar-icon d-flex align-items-center justify-content-center"/>
    }
    @else
    {
        <svg-icon src="assets/icons/warning.svg" class="snackbar-icon d-flex align-items-center justify-content-center"/>
    }
    <p class="nunito-regular snackbar-message">
        {{snackbarContent.message | translate}}
    </p>
</div>
